<script setup lang="ts">
import {
  colorIsDark,
  lighten,
  hexToRGB,
  setWhiteColor,
  setDeepBlue,
  setCustomColor
} from '@/utils/color'
import { ref, unref, computed, nextTick, onMounted } from 'vue'
import { trim, setCssVar } from '@/utils'
import { useCssVar } from '@vueuse/core'
import { useEmitt } from '@/hooks/web/useEmitt'
import { useCache } from '@/hooks/web/useCache'
import { useAppStore } from '@/store/modules/app'
import { useLocale } from '@/hooks/web/useLocale'
import { useLocaleStore } from '@/store/modules/locale'
// import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'

// const appStore = useAppStore()

// const currentSize = computed(() => appStore.getCurrentSize)
const showPage = ref(false)
const { emitter } = useEmitt()

const appStore = useAppStore()
const localeStore = useLocaleStore()
const { wsCache } = useCache()

// 头部主题相关
const colorRgb = (color) => {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  var sColor = color.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //处理六位的颜色值
    var sColorChange = []
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',0.3' + ')'
  } else {
    return sColor
  }
}

const setMenuTheme = (color: string) => {
  // const primaryColor = useCssVar('--el-color-primary', document.documentElement)
  const isDarkColor = colorIsDark(color)
  const theme: Recordable = {
    // 左侧菜单边框颜色
    leftMenuBorderColor: isDarkColor ? 'inherit' : '#eee',
    // 左侧菜单背景颜色
    leftMenuBgColor: color,
    // 左侧菜单浅色背景颜色
    leftMenuBgLightColor: isDarkColor ? lighten(color!, 6) : color,
    // 左侧菜单选中背景颜色
    // 左侧菜单字体颜色
    leftMenuTextColor: isDarkColor ? '#fff' : '#323233'
    // 左侧菜单选中字体颜色
    // leftMenuTextActiveColor: isDarkColor ? '#5AC8FA' : 'var(--el-color-primary)',
    // 左侧菜单选中字体颜色
    // leftMenuTextActiveColorSelf: isDarkColor ? '#fff' : '#323233',
    // logo字体颜色
    // logoTitleTextColor: isDarkColor ? '#fff' : 'inherit',
    // logo边框颜色
    // logoBorderColor: isDarkColor ? color : '#eee'
  }
  appStore.setTheme(theme)
  appStore.setCssVarTheme()
}

const setSystemTheme = (color: string) => {
  setCssVar('--el-color-primary', color)
  setCssVar('--el-color-new', color)
  setCssVar('--left-menu-text-active-color', color)
  if (color === '#5AC8FA') {
    console.log('执行我')
    setCssVar('--left-menu-bg-self-color', '#254251')
  } else if (color === '#008cd6') {
    setCssVar('--left-menu-bg-self-color', '#E5F6FF')
  } else {
    setCssVar('--left-menu-bg-self-color', colorRgb(color))
  }
  // const isDarkColor = colorIsDark(color)
  appStore.setTheme({
    leftMenuBgActiveColor: hexToRGB(unref(color), 0.1),
    // 左侧菜单收起选中背景颜色
    leftMenuCollapseBgActiveColor: hexToRGB(unref(color), 0.1)
  })
  appStore.setCssVarTheme()
  appStore.setTheme({ elColorPrimary: color })
  const leftMenuBgColor = useCssVar('--left-menu-bg-color', document.documentElement)
  setMenuTheme(trim(unref(leftMenuBgColor)))
}

const setHeaderTheme = (color: string) => {
  const isDarkColor = colorIsDark(color)

  if (color === '#fff') {
    const el = document.documentElement
    // 获取 css 变量
    getComputedStyle(el).getPropertyValue(`--el-color-primary`)
    // 设置 css 变量
    el.style.setProperty('--el-color-primary', '#008cd6')
    el.style.setProperty('--left-menu-text-color', '#5AC8FA')
    el.style.setProperty('--el-color-primary', '#008cd6')
    el.style.setProperty('--left-menu-text-color', '#5AC8FA')
    el.style.setProperty('--dark-bg', '#e6e6e6')
    el.style.setProperty('--power-dark-bg', '#ffffff')
    el.style.setProperty('--power-date-color', '#ffffff')
    el.style.setProperty('--power-dialog-bg', '#ffffff')
    el.style.setProperty('--power-dialog-table-bg', '#ffffff')
    el.style.setProperty('--power-btn-normal-bg', '#f6f6f6')
    el.style.setProperty('--power-btn-normal-bg-1', '#008CD6')
    el.style.setProperty('--power-btn-active-bg', '#e5f6ff')

    el.style.setProperty('--power-btn-cancel-bg', '#E1E1E1')
    el.style.setProperty('--power-btn-cancel-font-color', '#FFFFFF')
    el.style.setProperty('--power-btn-confirm-bg', '#008CD6')
    el.style.setProperty('--power-btn-confirm-font-color', '#FFFFFF')

    el.style.setProperty('--power-divider-vertical', '#C8C8C8')
    el.style.setProperty('--power-check-border', '#e5e7eb')
    el.style.setProperty('--power-check-hover', '#fff')
    el.style.setProperty('--power-tree-select-color', '#f0f0f0')

    /*滚动条颜色设置*/
    /*滚动条里面小方块*/
    el.style.setProperty('--webkit-scrollbar-thumb', '#c5c5c5')
    /*滚动条里面轨道*/
    el.style.setProperty('--webkit-scrollbar-track', '#ededed')

    el.style.setProperty('--el-table-row-hover-bg-color-self', '#f5f7fa')
    // el.style.setProperty('--xingHe-test', 'transparent')
    el.style.setProperty('--top-dark-bg', '#f0f0f0')
    el.style.setProperty('--table-border', '#006296')
    el.style.setProperty('--card-bg', '#ffffff')
    el.style.setProperty('--card-border', '#e1e1e1')
    el.style.setProperty('--title-color', '#515a6e')
    el.style.setProperty('--tree-font-color', '#515a6e')
    el.style.setProperty('--select-font-color', '#515a6e')
    el.style.setProperty('--button-bg', '#008cd6')
    el.style.setProperty('--btn-font-color', '#ffffff')
    // el.style.setProperty('--box-shadow', 'unset')
    // el.style.setProperty('--border-radius', 'unset')
    el.style.setProperty('--border-bg', 'unset')
    el.style.setProperty('--check-bg', '#409eff')
    el.style.setProperty('--page-color', '#515a6e')
    // el.style.setProperty('--btn-test-color', '#85969b')
    el.style.setProperty('--selected-cell-color', '#dcdfe6')
    el.style.setProperty('--table-hover-color', '#fafafa')
    el.style.setProperty('--popper-color', '#515a6e')
    el.style.setProperty('--el-header-bg', '#fafafa')
    el.style.setProperty('--transparent-inDark', '#ffffff')
    el.style.setProperty('--border-input', 'unset')
    el.style.setProperty('--box-shadow-light', '#dcdfe6')
    el.style.setProperty('--tree-node-icon', '#a8abb2')
    el.style.setProperty('--status-btn-bg-on', '#e3f0d3')
    el.style.setProperty('--status-btn-span-on', '#73b725')
    el.style.setProperty('--status-btn-bd-on', '#73b725')
    el.style.setProperty('--status-btn-bg-off', '#ffd6d6')
    el.style.setProperty('--status-btn-span-off', '#ce2f2f')
    el.style.setProperty('--status-btn-bd-off', '#ce2f2f')
    el.style.setProperty('--status-btn-bg-un', '#e1e1e1')
    el.style.setProperty('--status-btn-span-un', '787878')
    el.style.setProperty('--status-btn-bd-un', '#787878')
    el.style.setProperty('--tree-hover', '#ffffff')
    el.style.setProperty('--select-hover', '#E8F7FE')
    el.style.setProperty('--tree-border-color', '#dcdfe6')
    el.style.setProperty('--table-thead-color', '#787878')
    el.style.setProperty('--table-tbody-color', '#323233')
    el.style.setProperty('--page-total-color', '#787878')
    el.style.setProperty('--checkbox-border-color', '#383838')
    el.style.setProperty('--checkbox-back-color', '#fff')
    el.style.setProperty('--check-icon-color', '#fff')
    el.style.setProperty('--split-border-color', '#C5C5C5')
    el.style.setProperty('--eco-card-bg', '#fafafa')
    el.style.setProperty('--eco-col-bg', '#fff')
    el.style.setProperty('--eco-button-color', '#ADADAD')
    el.style.setProperty('--eco-button-bg', '#F6F6F6')
    el.style.setProperty('--eco-cascader-border', '#C8C8C8')
    el.style.setProperty('--eco-cascsder-tooltip-bg', '#fff')
    el.style.setProperty('--eco-button-select-color', '#008CD6')
    el.style.setProperty('--eco-button-select-bg', '#C6E6F9')
    el.style.setProperty('--eco-pagination-bg', '#F0F0F0')
    el.style.setProperty('--eco-kpi-region-bg', '#E2E2E2')
    el.style.setProperty('--eco-kpi-name-light', '#F7F7F7')
    el.style.setProperty('--eco-kpi-name-dark', '#ECECEC')
    el.style.setProperty('--eco-kpi-name-white', '#fff')
    el.style.setProperty('--eco-kpi-bg', '#fff')
    el.style.setProperty('--eco-kpi-son-bg', '#F7F7F7')
    el.style.setProperty('--eco-input-hover-bg', '#c0c4cc')
    el.style.setProperty('--eco-s3-bg', '#fafafa')
    el.style.setProperty('--eco-date-picker-border', '#fff')
    el.style.setProperty('--eco-date-picker-bg', '#fff')
    el.style.setProperty('--eco-date-picker-color', '#323233')
    el.style.setProperty('--eco-date-picker-range-bg', '#e8f3ff')
    el.style.setProperty('--eco-date-picker-range-color', '#323233')
    el.style.setProperty('--eco-checkbox-color', '#606266')
    el.style.setProperty('--border-top', '#e6e6e6')
    el.style.setProperty('--loss-title', '#323233')
    el.style.setProperty('--eco-energy-table', '#EDEDED')
    el.style.setProperty('--eco-report-table-color', '#323233')
    el.style.setProperty('--eco-el-scroll', 'rgba(50, 50, 51, 0.4)')
    el.style.setProperty('--new-button-bg', '#c6e6f9')
    el.style.setProperty('--new-button-text', '#008cd6')
    el.style.setProperty('--new-onActive-button-bg', '#f6f6f6')
    el.style.setProperty('--new-onActive-button-text', '#c5c5c5')
    el.style.setProperty('--eco-meter-bg', '#f5f5f5')
    el.style.setProperty('--eco-scroll-bg', '#c5c5c5')
    el.style.setProperty('--eco-custom-bg', '#ededed')
    el.style.setProperty('--eco-custom-color', '#787878')
    el.style.setProperty('--table-head-color', '#787878')
    el.style.setProperty('--eco-meter-split', '#006296')
    el.style.setProperty('--eco-time-split', '#ebeef5')
    el.style.setProperty('--eco-time-footer-border', '#e4e7ed')
    el.style.setProperty('--eco-drawer-bg', '#fff')
    el.style.setProperty('--eco-drawer-border', '#c8c8c8')
    el.style.setProperty('--eco-drawer-tree', '#fafafa')
    el.style.setProperty('--eco-drawer-region-bg', '#EDEDED')
    el.style.setProperty('--eco-button-cancel', '#E1E1E1')
    el.style.setProperty('--eco-type-bg', '#E1E1E1')
    el.style.setProperty('--eco-input-bg', '#fafafa')
    el.style.setProperty('--eco-green-text', '#00B900')
    el.style.setProperty('--eco-rank-red', '#DF001A')
    el.style.setProperty('--eco-button-disabled', '#c8c8c8')
    el.style.setProperty('--eco-interface-title', '#ececec')
    el.style.setProperty('--eco-tag-bg', '#f0f0f0')
    el.style.setProperty('--eco-checkbox-label', '#323233')
    el.style.setProperty('--eco-light-hover-bg', '#e1e1e1')
    el.style.setProperty('--eco-light-hover-border', '#c8c8c8')
    el.style.setProperty('--eco-light-active-bg', '#E5F6FF')
    el.style.setProperty('--eco-greenE-color', '#999999')
    el.style.setProperty('--eco-kpi-table-th', '#323233')
    el.style.setProperty('--eco-overview-CO2', '#787878')
    el.style.setProperty('--eco-interface-light', '#008CD6')
    el.style.setProperty('--eco-improve-completed', '#73B725')
    el.style.setProperty('--eco-improve-notStarted', '#787878')
    el.style.setProperty('--eco-improve-reformation', '#008CD6')
    el.style.setProperty('--eco-improve-table', '#F1F1F1')
    el.style.setProperty('--eco-improve-content', '#fff')
    el.style.setProperty('--eco-close-icon-color', '#008CD6')
    el.style.setProperty('--eco-close-icon-bg', '#E5F6FF')
    el.style.setProperty('--eco-param-color', '#fff')
    el.style.setProperty('--eco-table-header-bg', '#EDEDED')
    el.style.setProperty('--eco-table-even-bg', '#fff')
    el.style.setProperty('--eco-table-odd-bg', '#FAFAFA')

    el.style.setProperty('--hvac-date-list-select-tag-bg', '#ebebeb')
    el.style.setProperty('--hvac-card-title-stress', '#006EE6')
    el.style.setProperty('--hvac-card-bg', '#f5f5f5')
    el.style.setProperty('--hvac-card-border', '#dfdfdf')
    el.style.setProperty('--hvac-card-border-dashed', '#999999')
    el.style.setProperty('--hvac-card-border-dark', '#E6E6E6')
    el.style.setProperty('--hvac-card-border-light', '#c8c8c8')
    el.style.setProperty('--hvac-card-border-op', '#E6E6E6')
    el.style.setProperty('--hvac-card-border-op-2', '#E6E6E6')
    el.style.setProperty('--hvac-card-border-op-3', 'rgba(230, 230, 230, 0.5)')
    el.style.setProperty('--hvac-disabled-text', 'rgba(0, 0, 0, 0.25)')
    el.style.setProperty('--hvac-calendar-today-bg', '#DCF0FA')
    el.style.setProperty('--hvac-header-btn-color', '#999999')
    el.style.setProperty('--hvac-header-btn-icon-color', '#9FA7B7')
    el.style.setProperty('--hvac-dialog-mask', 'rgba(50, 50, 51, 0.5)')
    el.style.setProperty('--hvac-iframe-bg', '#fafafa')
    el.style.setProperty('--hvac-btn-text-disabled', '#c8c8c8')
    el.style.setProperty('--hvac-table-fixed-column-bg', '#e6e6e6')
    el.style.setProperty('--hvac-table-fixed-header-bg', '#f5f5f5')
    // 新加的样式
    el.style.setProperty('--hvac-table-title-text', '#323233') //表头标题
    el.style.setProperty('--hvac-table-header', '#F5F5F5')
    el.style.setProperty('--hvac-colunm-first', '#E5E5E5')
    el.style.setProperty('--hvac-row-all', '#DCF0FA')
    el.style.setProperty('--hvac-text-sum', '#006296')
    el.style.setProperty('--hvac-table-text-color', '#323233')
    el.style.setProperty('--hvac-table-even-color', '#FFFFFF')
    el.style.setProperty('--hvac-table-border-color', '#C8C8C8')
    el.style.setProperty('--hvac-header-border-bottom', '#006296')
    el.style.setProperty('--hvac-header-border-top', '#C8C8C8')
    el.style.setProperty('--hvac-radio-color', '#787878')
    el.style.setProperty('--hvac-title-body-bgColor', '#fafafa')
    el.style.setProperty('--hvac-table-header-border', '#006296')
  } else {
    const el = document.documentElement
    // const el = document.getElementById('xxx')
    // 获取 css 变量
    getComputedStyle(el).getPropertyValue(`--el-color-primary`)
    // 设置 css 变量
    el.style.setProperty(
      '--dark-bg',
      'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
    )
    el.style.setProperty(
      '--power-dark-bg',
      'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
    )
    el.style.setProperty('--el-color-primary', '#5AC8FA')
    el.style.setProperty('--left-menu-text-color', '#fff')
    el.style.setProperty('--el-color-primary', '#5AC8FA')
    el.style.setProperty('--left-menu-text-color', '#fff')
    el.style.setProperty('--power-date-color', '#85969b')
    el.style.setProperty('--power-dialog-bg', '#17293C')
    el.style.setProperty('--power-dialog-table-bg', '#1e3146')
    el.style.setProperty('--power-btn-normal-bg', '#2B3B4B 30%')
    el.style.setProperty('--power-btn-normal-bg-1', '#5AC8FA')
    el.style.setProperty('--power-btn-active-bg', '#254251')

    el.style.setProperty('--power-btn-cancel-bg', '#3F4D5A')
    el.style.setProperty('--power-btn-cancel-font-color', '#85969B')
    el.style.setProperty('--power-btn-confirm-bg', '#5AC8FA')
    el.style.setProperty('--power-btn-confirm-font-color', '#17293C')

    el.style.setProperty('--power-divider-vertical', '#576E7D')
    el.style.setProperty('--power-check-border', '#17293c')
    el.style.setProperty('--power-check-hover', '#17293c')
    el.style.setProperty('--power-tree-select-color', '#17293c')

    /*滚动条颜色设置*/
    /*滚动条里面小方块*/
    el.style.setProperty('--webkit-scrollbar-thumb', '#51646B')
    /*滚动条里面轨道*/
    el.style.setProperty('--webkit-scrollbar-track', 'rgba(255, 255, 255, 0)')

    el.style.setProperty('--el-table-row-hover-bg-color-self', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--xingHe-test', 'transparent')
    el.style.setProperty('--top-dark-bg', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--table-border', 'rgba(85, 137, 155, 0.3)')
    el.style.setProperty('--card-bg', '#141F26')
    el.style.setProperty('--card-border', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--title-color', '#ffffff')
    el.style.setProperty('--tree-font-color', '#ffffff')
    el.style.setProperty('--select-font-color', '#5AC8FA')
    el.style.setProperty('--button-bg', '#5AC8FA')
    el.style.setProperty('--btn-font-color', '#ffffff')
    el.style.setProperty('--box-shadow', 'unset')
    el.style.setProperty('--border-radius', 'unset')
    el.style.setProperty('--border-bg', '#5AC8FA')
    el.style.setProperty('--check-bg', '#5AC8FA')
    el.style.setProperty('--page-color', '#5AC8FA')
    el.style.setProperty('--btn-test-color', '#85969b')
    el.style.setProperty('--selected-cell-color', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--table-hover-color', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--popper-color', '#ffffff')
    el.style.setProperty('--el-header-bg', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--transparent-inDark', 'transparent')
    el.style.setProperty('--border-input', 'unset')
    el.style.setProperty('--box-shadow-light', 'rgba(85, 137, 155, 0.3)')
    el.style.setProperty('--tree-node-icon', '#ffffff')
    el.style.setProperty('--status-btn-bg-on', '#233C29')
    el.style.setProperty('--status-btn-span-on', '#33C733')
    el.style.setProperty('--status-btn-bd-on', '#33C733')
    el.style.setProperty('--status-btn-bg-off', '#352529')
    el.style.setProperty('--status-btn-span-off', '#E53348')
    el.style.setProperty('--status-btn-bd-off', '#E53348')
    el.style.setProperty('--status-btn-bg-un', '#334353')
    el.style.setProperty('--status-btn-span-un', '#85969B')
    el.style.setProperty('--status-btn-bd-un', '#85969B')
    el.style.setProperty('--tree-hover', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--select-hover', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--tree-border-color', '#ffffff')
    el.style.setProperty('--table-thead-color', '#85969B')
    el.style.setProperty('--table-tbody-color', '#fff')
    el.style.setProperty('--page-total-color', '#85969B')
    el.style.setProperty('--checkbox-border-color', '#fff')
    el.style.setProperty('--checkbox-back-color', '#323233')
    el.style.setProperty('--check-icon-color', '#141F26')
    el.style.setProperty('--split-border-color', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-card-bg', '#141f26')
    el.style.setProperty('--eco-col-bg', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--eco-button-color', '#51646B')
    el.style.setProperty('--eco-button-bg', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-cascader-border', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-cascsder-tooltip-bg', '#17293C')
    el.style.setProperty('--eco-button-select-color', '#5AC8FA')
    el.style.setProperty('--eco-button-select-bg', '#254251')
    el.style.setProperty('--eco-pagination-bg', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-kpi-region-bg', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--eco-kpi-name-light', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-kpi-name-dark', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--eco-kpi-name-white', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--eco-kpi-bg', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--eco-kpi-son-bg', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-input-hover-bg', '#5AC8FA')
    el.style.setProperty('--eco-s3-bg', '#17293C')
    el.style.setProperty('--eco-date-picker-border', '#9FA7B7')
    el.style.setProperty('--eco-date-picker-bg', '#334353')
    el.style.setProperty('--eco-date-picker-color', '#9FA7B7')
    el.style.setProperty('--eco-date-picker-range-bg', '#254251')
    el.style.setProperty('--eco-date-picker-range-color', '#85969B')
    el.style.setProperty('--eco-checkbox-color', '#fff')
    el.style.setProperty('--border-top', '#141F26')
    el.style.setProperty('--loss-title', '#fff')
    el.style.setProperty('--eco-energy-table', 'transparent')
    el.style.setProperty('--eco-report-table-color', '#85969B')
    el.style.setProperty('--eco-el-scroll', '#51646B')
    el.style.setProperty('--eco-param-color', '#000')
    el.style.setProperty('--new-button-bg', '#254251')
    el.style.setProperty('--new-button-text', '#5AC8FA ')
    el.style.setProperty('--new-onActive-button-bg', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--new-onActive-button-text', '#51646B')
    el.style.setProperty('--eco-meter-bg', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-scroll-bg', '#51646B')
    el.style.setProperty('--eco-custom-bg', '#334353')
    el.style.setProperty('--eco-custom-color', '#85969B')
    el.style.setProperty('--table-head-color', '#85969B')
    el.style.setProperty('--eco-meter-split', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-time-split', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-time-footer-border', 'rgba(85, 137, 155, 0.3)')
    el.style.setProperty('--eco-drawer-bg', '#17293C')
    el.style.setProperty('--eco-drawer-border', '#576E7D')
    el.style.setProperty('--eco-drawer-tree', '#212D3B')
    el.style.setProperty('--eco-drawer-region-bg', '#2B3B4B')
    el.style.setProperty('--eco-button-cancel', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--eco-type-bg', '#576E7D')
    el.style.setProperty('--eco-input-bg', '#141F26')
    el.style.setProperty('--eco-green-text', '#33C733')
    el.style.setProperty('--eco-rank-red', '#E53348')
    el.style.setProperty('--eco-button-disabled', '#334353')
    el.style.setProperty('--eco-interface-title', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--eco-tag-bg', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-checkbox-label', '#5AC8FA')
    el.style.setProperty('--eco-light-hover-bg', '#3F4D5A')
    el.style.setProperty('--eco-light-hover-border', 'rgba(87, 110, 125, 0.3)')
    el.style.setProperty('--eco-light-active-bg', '#254251')
    el.style.setProperty('--eco-greenE-color', '#85969B')
    el.style.setProperty('--eco-kpi-table-th', '#FFFFFF')
    el.style.setProperty('--eco-overview-CO2', '#85969B')
    el.style.setProperty('--eco-interface-light', '#5AC8FA')
    el.style.setProperty('--eco-improve-completed', '#33C733')
    el.style.setProperty('--eco-improve-notStarted', '#51646B')
    el.style.setProperty('--eco-improve-reformation', '#008CD6')
    el.style.setProperty('--eco-improve-table', 'rgba(43, 59, 75, 0.3)')
    el.style.setProperty('--eco-improve-content', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--eco-close-icon-color', '#5AC8FA')
    el.style.setProperty('--eco-close-icon-bg', '#254251')
    el.style.setProperty('--eco-table-header-bg', '#364850')
    el.style.setProperty('--eco-table-even-bg', '#293946')
    el.style.setProperty('--eco-table-odd-bg', '#202E36')

    el.style.setProperty('--hvac-date-list-select-tag-bg', '#334353')
    el.style.setProperty('--hvac-card-title-stress', '#0062CC')
    el.style.setProperty('--hvac-card-bg', '#2b3b4b')
    el.style.setProperty('--hvac-card-border', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--hvac-card-border-dashed', 'rgba(133, 150, 155, 0.3)')
    el.style.setProperty('--hvac-card-border-dark', 'rgba(133, 150, 155, 0.3)')
    el.style.setProperty('--hvac-card-border-light', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--hvac-card-border-op', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--hvac-card-border-op-2', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--hvac-card-border-op-3', 'rgba(63, 77, 90, 0.5)')
    el.style.setProperty('--hvac-disabled-text', 'rgba(85, 137, 155, 0.3)')
    el.style.setProperty('--hvac-calendar-today-bg', '#254251')
    el.style.setProperty('--hvac-header-btn-color', '#51646B')
    el.style.setProperty('--hvac-header-btn-icon-color', '#51646B')
    el.style.setProperty('--hvac-dialog-mask', 'rgba(0, 0, 0, 0.6)')
    el.style.setProperty('--hvac-iframe-bg', '#0C1216')
    el.style.setProperty('--hvac-btn-text-disabled', '#51646b')
    el.style.setProperty('--hvac-table-fixed-column-bg', '#2B3B4B')
    el.style.setProperty('--hvac-table-fixed-header-bg', '#263542')
    // 新加的样式
    el.style.setProperty('--hvac-table-title-text', '#B9C1C4')
    el.style.setProperty('--hvac-table-header', 'rgba(81, 100, 107, 0.4)')
    el.style.setProperty(
      '--hvac-colunm-first',
      'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
    )
    el.style.setProperty('--hvac-row-all', '#254251')
    el.style.setProperty('--hvac-text-sum', '#C6E6F9')
    el.style.setProperty('--hvac-table-text-color', '#B9C1C4')
    el.style.setProperty('--hvac-table-even-color', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--hvac-table-border-color', '#51646B')
    el.style.setProperty('--hvac-header-border-bottom', '#C6E6F9')
    el.style.setProperty('--hvac-header-border-top', '#51646B')
    el.style.setProperty('--hvac-radio-color', '#85969B')
    el.style.setProperty('--hvac-title-body-bgColor', 'rgba(95, 117, 162, 0.1)')
    el.style.setProperty('--hvac-table-header-border', 'rgba(85, 137, 155, 0.3)')
  }

  const topHeaderLeftLogoColor = isDarkColor ? '#212D3B' : '#E5F6FF'
  const topHeaderLeftLogoTextColor = isDarkColor ? '#5AC8FA' : '#008CD6'
  const logoTextColor = isDarkColor ? '#008cd6' : '#004280'
  const textColor = isDarkColor ? '#fff' : '#323233'
  const textHoverColor = isDarkColor ? lighten(color!, 6) : '#f6f6f6'
  const topToolBorderColor = isDarkColor ? color : '#eee'
  const topHeaderBottomColor = isDarkColor ? '#0a0000' : '#DDDEE2FF'
  const topHeaderRightIconColor = isDarkColor ? '#fff' : '#89898A'
  setCssVar('--top-header-left-logo-color', topHeaderLeftLogoColor)
  setCssVar('--top-header-left-logo-text-color', topHeaderLeftLogoTextColor)
  setCssVar('--top-header-logo-color', logoTextColor)
  setCssVar('--top-header-bottom-color', topHeaderBottomColor)
  setCssVar('--top-header-right-icon-color', topHeaderRightIconColor)
  setCssVar('--top-header-bg-color', color)
  setCssVar('--top-header-text-color', textColor)
  setCssVar('--top-header-hover-color', textHoverColor)
  setCssVar('--top-tool-border-color', topToolBorderColor)
  appStore.setTheme({
    topHeaderBgColor: color,
    topHeaderTextColor: textColor,
    topHeaderHoverColor: textHoverColor,
    topToolBorderColor,
    topHeaderLeftLogoColor,
    topHeaderLeftLogoTextColor,
    logoTextColor,
    topHeaderBottomColor,
    topHeaderRightIconColor
  })
  emitter.emit('switchEcoColor', {
    color
  })
  emitter.emit('switchColor', {
    color
  })
  emitter.emit('switchColor', {
    color
  })
}

// 切换语言
const setLang = (lang: LocaleType) => {
  localeStore.setCurrentLocale({
    lang
  })
  const { changeLocale } = useLocale()
  changeLocale(lang)
}

const orgId = ref('')
const lang = ref<LocaleType>('zh-cn')
const theme = ref('#fff')
const themeObj = computed(() => {
  const obj = {
    ['#fff']: {
      systemTheme: '#008cd6',
      headerTheme: '#fff',
      menuTheme: '#f0f0f0',
      bodyTheme: 'defaultOne',
      ID: 1
    },
    ['#2B3B4B']: {
      systemTheme: '#5AC8FA',
      headerTheme: '#2B3B4B',
      menuTheme: '#141B27',
      bodyTheme: 'defaultTwo',
      ID: 2
    }
  }
  return obj[theme.value] || obj['#fff']
})
const currentSize = computed(() => appStore.getCurrentSize)

console.log('window.$wujie', (window as any).$wujie)

// 切换色系
const changeTheme = () => {
  if (theme.value === '#fff') {
    setWhiteColor()
    setSystemTheme('#008cd6')
    setHeaderTheme('#fff')
    setMenuTheme('#f0f0f0')
    let objTheme = {
      systemTheme: '#008cd6',
      headerTheme: '#fff',
      menuTheme: '#f0f0f0',
      bodyTheme: 'defaultOne'
    }
    localStorage.setItem('currentTheme', themeObj.value.ID)
    localStorage.setItem('ThemeColor', JSON.stringify(objTheme))
  } else if (theme.value === '#2B3B4B') {
    setDeepBlue()
    setSystemTheme('#5AC8FA')
    setHeaderTheme('#2B3B4B')
    setMenuTheme('#141B27')
    localStorage.setItem('currentTheme', themeObj.value.ID)
    let objTheme = {
      systemTheme: '#5AC8FA',
      headerTheme: '#2B3B4B',
      menuTheme: '#141B27',
      bodyTheme: 'defaultTwo'
    }
    localStorage.setItem('ThemeColor', JSON.stringify(objTheme))
  } else {
    setSystemTheme(themeObj.value.systemTheme)
    setHeaderTheme(themeObj.value.headerTheme)
    setMenuTheme(themeObj.value.menuTheme)
    localStorage.setItem('currentTheme', themeObj.value.ID)
    let objTheme = {
      systemTheme: themeObj.value.systemTheme,
      headerTheme: themeObj.value.headerTheme,
      menuTheme: themeObj.value.menuTheme,
      bodyTheme: themeObj.value.bodyTheme
    }
    localStorage.setItem('ThemeColor', JSON.stringify(objTheme))
    setCustomColor(objTheme.bodyTheme, objTheme.systemTheme, objTheme.headerTheme)
  }
}

const init = () => {
  orgId.value = '1'
  lang.value = 'zh-cn'
  theme.value = '#fff'

  if ((window as any)?.$wujie?.props && (window as any)?.$wujie?.props?.lang) {
    console.log('window?.$wujie?.props?.lang', (window as any)?.$wujie?.props?.lang)
    lang.value = (window as any)?.$wujie?.props?.lang || 'zh-cn'
    theme.value = (window as any)?.$wujie?.props?.theme || '#fff'
    orgId.value = (window as any)?.$wujie?.props?.orgId + '' || '1'
  }

  // 主题色
  changeTheme()

  // 多语言
  setLang(lang.value)
  console.log('lang', lang.value)
  wsCache.set('child_lang', lang.value)

  // org-id
  localStorage.setItem('currentOrgIdMarker', orgId.value)
  console.log('----------orgId.value', orgId.value)

  nextTick(() => {
    showPage.value = true
  })
}
init()

onMounted(() => {
  ;(window as any)?.$wujie?.bus?.$on('iemsTheme', (val) => {
    theme.value = val
    changeTheme()
  })
  console.log('33333333333333333333333333window.$wujie3', (window as any).$wujie)
})
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView v-if="showPage" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}
#v-menu .el-scrollbar__view {
  background-color: var(--left-menu-bg-color) !important;
}

html,
body {
  font-family: 'Microsoft JhengHei' !important;
  padding: 0;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }

  .el-card__body {
    padding: var(--el-card-padding-self);
    height: inherit;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
.el-button:not(.is-text) {
  //background: #008cd6 !important;
}
.el-card__header {
  padding: calc(var(--el-card-padding) - 15px) calc(var(--el-card-padding) - 15px) !important;
  background: #f3f3f3;
}
#v-menu .el-scrollbar__view {
  background-color: var(--left-menu-bg-color) !important;
}
</style>
<style scoped>
:deep(.el-loading-mask) {
  background: var(--card-bg) !important;
}
</style>
